import { AlaFormulario } from './../domain/AlaFormulario';
import { Component, EventEmitter, Input, Output, Inject, forwardRef, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { AuthenticationService } from '../providers/authentication/authentication.service';
import { element } from 'protractor';
import { NodoFormulario, NodoIdiomaFormulario } from '../domain/NodoFormulario';
import {InputSwitchModule} from 'primeng/inputswitch';
import { Idioma } from '../domain/Idioma';
import * as allSettled from 'promise-all-settled';
import { Constantes } from '../domain/constantes';
import { IdiomaService } from '../providers/idioma/idioma.service';
import {TranslatePipe, TranslateService, LangChangeEvent} from 'ng2-translate';
import { Contenido } from '../domain/Contenido';
import { MenuItem } from 'primeng/api';
import { ConexionFormulario } from '../domain/ConexionFormulario';
import { Predicate } from 'breeze-client';
import { AppComponent } from '../app.component';
import { ServiciosWebServiceProvider } from '../providers/web-service-service/servicios-web-service';
import { PermisosService, Permisos } from '../providers/authentication/permisos.service';
import { BalizaFormulario } from '../domain/BalizaFormulario';

@Component({
  selector: 'app-formulario-nodo',
  templateUrl: './FormularioNodo.component.html'
})

export class FormularioNodoComponent implements OnInit, OnChanges, OnDestroy {

	@Input() nodoSeleccionado: NodoFormulario = new NodoFormulario();
	@Input() resumenContenidosAsociados = [{ 	Tipo: '',
												IconoRepresentacion: '',
												Cantidad: 0 }];
	@Input() idiomaSeleccionado: Idioma;
	@Input() edicion: boolean;
	@Input() tipologias: any[];
	// @Input() tipologiasSeleccionada: any[];
	@Input() confirmacionVisible: boolean;
	@Input() msgs: any[];
	@Input() visible: boolean = true;

	@Input() alaDestinoPortal: AlaFormulario;
	@Input() alaOrigenPortal: AlaFormulario;
	@Input() balizaAsociarSeleccionada: BalizaFormulario;

	@Output() onElementoDescartado: EventEmitter <any> = new EventEmitter();

	@Output() onElementoGuardado: EventEmitter <any> = new EventEmitter();
	@Output() onElementoError: EventEmitter <any> = new EventEmitter();
	@Output() onElementoEliminado: EventEmitter <any> = new EventEmitter();

	@Output() onFormularioValidation: EventEmitter <boolean> = new EventEmitter();

	@Output() onNodoPortalCrearPressed: EventEmitter <any> = new EventEmitter();
	@Output() onNodoPortalCancelPressed: EventEmitter <any> = new EventEmitter();
	@Output() onNodoPortalChange: EventEmitter <any> = new EventEmitter();
	@Output() onNodoPortalEliminado: EventEmitter <any> = new EventEmitter();

	@Output() onAlaPortalChange: EventEmitter <any> = new EventEmitter();
	@Output() onConexionPortalSeleccionada: EventEmitter <any> = new EventEmitter();

	public isValid = true;
	public seleccionTipologia: any;
	public selectedPortales: any[] = [];
	public cancelarGuardado = true;

	perfilesMovilidad: any[] = [];
	perfilesMovilidadDefecto: any;

	colsPortal;
	msgsPortal=[];

	types: any[];
	selectedTypes: string[] = [];

	operacion;

	/* IDIOMA */
	// @Input() idiomaSeleccionado: Idioma;
	idiomas;
	idiomaDefecto: Idioma;

	// Portal
	tabNODEMenuItems: MenuItem[];
	activeNODOMenuItem: MenuItem;
	tabPortalNodo: boolean = false;
	tabEditarNodo: boolean = true;
	tabBalizaNodo: boolean = false;
	visibleCrearPortal: boolean = false;
	seleccionandoNodoDestino: boolean = false;
	@Input() alasPortal: AlaFormulario[] = [];
	conexionesConPortales: any[] = [];
	conexionesPortalSeleccionada: any = new ConexionFormulario();
	conexionesPortalSeleccionadaVuelta: any = new ConexionFormulario();

	blockUI: HTMLElement;
	spinner: HTMLElement;

	msgInfoBaliza: any[];
	msgsComoAsignar: any[];
	msgInfoPortal: any[];
	msgAvisoAsignar: any[];

	permisos: Permisos = new Permisos();
	balizas = [];
	balizasMostrar = [];

	constructor(
		private appComponent: AppComponent,
		private entityManagerProvider: EntityManagerProvider,
		public authService: AuthenticationService,
		private idiomaService: IdiomaService,
		private sws: ServiciosWebServiceProvider,
		private translate: TranslateService,
		private permisosService: PermisosService) {
			this.colsPortal = [
				{ field: 'Nombre', header: this.translate.instant('Formularios.nombre') }
			];

			const that = this;
			// Inicializamos Spinner
			this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
			this.spinner.style.display = 'none';
			this.entityManagerProvider.getIDIOMA()
			.then(function (idiomasENTIDAD: any) {

				that.idiomas = [];
				idiomasENTIDAD.forEach(idioma => {
					if(idioma.Visible === true){
					that.idiomas.push(new Idioma(idioma));
					}
				});

				that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
				that.idiomaSeleccionado = that.idiomaDefecto;

			});

			this.tabNODEMenuItems = [
				{
					label: this.translate.instant('Mapas.editar'),
					command: (event: any) => {
						this.tabNodoSeleccionada(event);
					}
				},
				{
					label: this.translate.instant('Mapas.portales'),
					command: (event: any) => {
						this.tabPortalesSeleccionada(event);
					}
				},
				{
					label: this.translate.instant('Mapas.balizas'),
					command: (event: any) => {
						this.tabBalizasSeleccionada(event);
					}
				}
			];
			this.activeNODOMenuItem = this.tabNODEMenuItems[0];
			this.tabPortalNodo = false;
			this.tabBalizaNodo = false;
			this.tabEditarNodo = true;

			this.msgInfoBaliza =  [];
			this.msgInfoBaliza.push( {severity: 'info', detail: this.translate.instant('Beacons.msgInfoBaliza')} );
			this.msgsComoAsignar = [];
			this.msgsComoAsignar.push( {severity: 'info', detail: this.translate.instant('Beacons.msgsComoAsignar')} );

			this.msgInfoPortal =  [];
			this.msgInfoPortal.push( {severity: 'info', detail: this.translate.instant('Formularios.msgInfoPortal')} );

			this.blockUI = document.getElementsByClassName('blockUI')[0] as HTMLElement;
			this.blockUI.style.display = 'none';

	}

	/* ************************************************************************** */
	/*                            COMUN FORMULARIO                                */
	/* ************************************************************************** */

	ngOnInit(): void {
		this.comprobarPermisos();
	}

	ngOnDestroy(){
		if (this.cancelarGuardado) {
			this.entityManagerProvider.RejectChanges();
		}
		this.seleccionandoNodoDestino = false;
		this.onAlaPortalChange.emit(this.alaOrigenPortal);
		// this.onNodoPortalCancelPressed.emit();
	}


	ngOnChanges(changes: SimpleChanges): void {

		let cambionodoSeleccionado = changes['nodoSeleccionado'];

		// Cogemos las conexiones en las que el nodo es origen y esta conectado con otro portal
		if (cambionodoSeleccionado && cambionodoSeleccionado.currentValue.ENTIDAD.CONEXIONS_NODOS_ORIGEN) {
				this.idiomaSeleccionado = this.idiomaDefecto;
				this.confirmacionVisible = false;
				this.onIdiomaChange({value: this.idiomaSeleccionado});

				const nodoOrigen: NodoFormulario = cambionodoSeleccionado.currentValue;
				this.alaOrigenPortal = new AlaFormulario(nodoOrigen.ENTIDAD.SECCION.ALA);

				this.conexionesConPortales = [];
				nodoOrigen.ENTIDAD.CONEXIONS_NODOS_ORIGEN.forEach(elemento => {
					if (elemento.NodoDestino.EsPortal && elemento.NodoOrigen.EsPortal) {
						this.conexionesConPortales.push(elemento);
					}
				});

				this.conexionesConPortales = this.conexionesConPortales.sort(
					(a, b) => a.NodoDestino.SECCION.ALA.NIVEL.NivelVertical - b.NodoDestino.SECCION.ALA.NIVEL.NivelVertical
				);
		}

		cambionodoSeleccionado = changes['balizaAsociarSeleccionada'];
		if (cambionodoSeleccionado && this.tabBalizaNodo) {

			const baliza: BalizaFormulario = cambionodoSeleccionado.currentValue;

			console.log('Vamos a asociar: ' + baliza.Id);

			
			if(baliza.ENTIDAD){
				if(baliza.ENTIDAD.TIPOLOGIA_BALIZA){
					if(baliza.ENTIDAD.TIPOLOGIA_BALIZA.esBeacon === true || baliza.ENTIDAD.TIPOLOGIA_BALIZA.esSniffer === true){
						const encontrada = this.nodoSeleccionado.balizas.find( x => x.Id === baliza.Id);
						if (encontrada) {
							this.nodoSeleccionado.balizas = this.nodoSeleccionado.balizas.filter( x => x.Id !== baliza.Id);
							this.balizasMostrar = this.balizasMostrar.filter( x => x.Id !== baliza.Id);
						}
						else{
							//console.log(baliza)
							this.nodoSeleccionado.balizas.push(baliza);
							this.balizasMostrar.push(baliza)
							//console.log(this.nodoSeleccionado.balizas)
						}
					}else{
						console.log(this.nodoSeleccionado.balizas)
						console.log(this.balizasMostrar)	
						this.msgAvisoAsignar = [];
						this.msgAvisoAsignar.push( {severity: 'warn', detail: 'La tipología de esta baliza impide asignarla o desasignarla al nodo.'} );
						setTimeout(() => {
							this.msgAvisoAsignar = [];
						}, 3000);
					}
				}
			}

		}
	}

	public onTipologiaChange(event) {

	}

	inputChanged(value) {
		//  Cojemos la traduccion del nodo al idioma seleccionado
		const nodoIdioma = this.nodoSeleccionado.Idiomas.get(this.idiomaSeleccionado.ENTIDAD.Codigo);

		// Guardamos los posibles cambios del idioma
		nodoIdioma.Nombre = this.nodoSeleccionado.Nombre;
		nodoIdioma.Descripcion = this.nodoSeleccionado.Descripcion;
		nodoIdioma.NombreSeccion = this.nodoSeleccionado.NombreSeccion;
		this.nodoSeleccionado.Idiomas.set(this.idiomaSeleccionado.ENTIDAD.Codigo, nodoIdioma);
	}


	public esEdicion(): boolean {
		return this.nodoSeleccionado && (this.nodoSeleccionado.Id ? true : false);
	}

	public validar(): boolean {
		console.warn('Implementar: validar');
		if (!this.nodoSeleccionado.Nombre) {
			this.isValid = false;
		}
		else {
			this.isValid = true;
		}

		this.onFormularioValidation.emit(this.isValid);

		return this.isValid;
	}

	public guardar(): any {
		if (this.validar()) {
			this.spinner.style.display = 'inherit';
			if (!this.esEdicion()) {
				this.guardarNuevo();
			}
			else {
				this.guardarEdicion();
			}

		} else {
			this.appComponent.showError(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
			this.confirmacionVisible = false;
			console.log(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
		}
	}

	public guardarNuevo () {
	}

	public guardarEdicion () {
		const that = this;
		this.cancelarGuardado = false;
		const promises: any[] = [];
		const nodosConectados: any[] = [];
		const nodosNoConectados: any[] = [];

		this.guardarMultiIdioma()
		.then(function(){
			if (that.nodoSeleccionado === undefined || that.nodoSeleccionado === null) {
				return that.translate.instant('Formularios.noseleccionado');
			}
			if (!that.nodoSeleccionado.Id) {
				return that.translate.instant('Formularios.operacionnovalida');
			}

			const nodoIdioma = that.nodoSeleccionado.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.nodoSeleccionado.Nombre = nodoIdioma.Nombre ? nodoIdioma.Nombre : '';
			that.nodoSeleccionado.Descripcion = nodoIdioma.Descripcion ? nodoIdioma.Descripcion : '';

			that.nodoSeleccionado.ENTIDAD.Nombre = that.nodoSeleccionado.Nombre;
			that.nodoSeleccionado.ENTIDAD.Descripcion = that.nodoSeleccionado.Descripcion;
			that.nodoSeleccionado.ENTIDAD.X = that.nodoSeleccionado.X;
			that.nodoSeleccionado.ENTIDAD.Y = that.nodoSeleccionado.Y;
			that.nodoSeleccionado.ENTIDAD.IdSeccion = that.nodoSeleccionado.IdSeccion;

			that.nodoSeleccionado.ENTIDAD.CalidadPotenciaTxMin = that.nodoSeleccionado.CalidadPotenciaTxMin;
			that.nodoSeleccionado.ENTIDAD.CalidadNumBeaconsMin = that.nodoSeleccionado.CalidadNumBeaconsMin;

			that.nodoSeleccionado.ENTIDAD.IdTipologia = that.nodoSeleccionado.TIPOLOGIA_NODO.Id;
			if (that.nodoSeleccionado.TIPOLOGIA_NODO.MostrarDestinoSugerido) {
				that.nodoSeleccionado.ENTIDAD.EsPDI = true;
			}
			else{
				that.nodoSeleccionado.ENTIDAD.EsPDI = false;
			}

			that.nodoSeleccionado.ENTIDAD.EsEntrada = that.nodoSeleccionado.EsEntrada;

			that.nodoSeleccionado.NODO_PLANO.setNombre(that.nodoSeleccionado.Nombre);
			if (that.nodoSeleccionado.ENTIDAD.TIPOLOGIA_NODO) {
				that.nodoSeleccionado.NODO_PLANO.setSimbolo(that.nodoSeleccionado.ENTIDAD.TIPOLOGIA_NODO.IconoRepresentacion);
			}

			that.nodoSeleccionado.NODO_PLANO.conexiones.forEach(conexionPlano => {
				that.nodoSeleccionado.ENTIDAD.CONEXIONS_NODOS_ORIGEN.forEach(conexion => {
					if (conexion.Id === conexionPlano.getId()) {
						conexion.CoordenadasCamino = JSON.stringify(conexionPlano.getRuta());
					}
				});

				that.nodoSeleccionado.ENTIDAD.CONEXIONS_NODOS_DESTINO.forEach(conexion => {
					if (conexion.Id === conexionPlano.getId()) {
						conexion.CoordenadasCamino = JSON.stringify(conexionPlano.getRuta());
					}
				});
			});

			// Comprobamos si el nodo antes de la edicion era portal y despues de la edicion no es portal:
			// Entonces borramos todas las conexiones entre el y los nodos portal que existieran
			if (!that.nodoSeleccionado.EsPortal && that.nodoSeleccionado.ENTIDAD.EsPortal ) {

				console.log('Borrar todas las conexiones con los portales');
				const conexionesBorradas = [];

				// CONEXIONS_NODOS_DESTINO
				 let aux = that.nodoSeleccionado.ENTIDAD.CONEXIONS_NODOS_DESTINO.filter( x => x.NodoDestino.EsPortal && x.NodoOrigen.EsPortal);

				 for (let index = aux.length - 1; index >= 0; index--) {

					const elemento = aux[index];
					conexionesBorradas.push(elemento);
					try {
						that.entityManagerProvider.deleteCascadaCONEXION_NODO(elemento);
					} catch (e) {
						console.log('ERROR: error al leer un ALA: ' + e);
					}
				}

				// CONEXIONS_NODOS_ORIGEN
				aux = that.nodoSeleccionado.ENTIDAD.CONEXIONS_NODOS_ORIGEN.filter( x => x.NodoDestino.EsPortal && x.NodoOrigen.EsPortal);
				for (let index = aux.length - 1; index >= 0; index--) {

					const elemento = aux[index];
					conexionesBorradas.push(elemento);
					try {
						that.entityManagerProvider.deleteCascadaCONEXION_NODO(elemento);
					} catch (e) {
						console.log('ERROR: error al leer un ALA: ' + e);
					}
				}
				that.onNodoPortalEliminado.emit({ result: true, element: conexionesBorradas });
			}


			// Si el nodo seleccionado es portal tenemos que revisar que existan conexiones entre el y los nodos portal que se esten seleccionados
			if (that.nodoSeleccionado.EsPortal) {

				that.selectedPortales.forEach(nodo => {
					const conexionesConPortales = that.nodoSeleccionado.ENTIDAD.CONEXIONS_NODOS_ORIGEN.filter( x => x.NodoDestino.Id === nodo.Id);

					if (conexionesConPortales.length > 0) {
						nodosConectados.push(nodo);
					}
					else{
						nodosNoConectados.push(nodo);
					}
				});

				nodosNoConectados.forEach(nodo => {
					// Nueva conexion Origen
					promises.push(that.entityManagerProvider.newCONEXION_NODOS());
				});
			}

			that.nodoSeleccionado.ENTIDAD.EsPortal = that.nodoSeleccionado.EsPortal;

			return allSettled(promises);
		})
		.then(function(conexiones){

			for (let index = 0; index < nodosNoConectados.length; index++) {
				const nodo = nodosNoConectados[index];
				const conexionOrigen = conexiones[index];
				console.log('TODO: para cada Nueva conexion Origen Crear un peso_conexion para cada conexion con cada perfil de movilidad');
			}

			nodosNoConectados.forEach(nodo => {
				// Nueva conexion Destino
				promises.push(that.entityManagerProvider.newCONEXION_NODOS());
			});

			return allSettled(promises);
		})
		.then(function(conexiones){

			for (let index = 0; index < nodosNoConectados.length; index++) {
				const nodo = nodosNoConectados[index];
				const conexionDestino = conexiones[index];
				console.log('TODO: para cada Nueva Destino Origen Crear un peso_conexion para cada conexion con cada perfil de movilidad');
			}

			// return that.entityManagerProvider.saveChanges();
			const token = that.authService.getToken();
			const idEspacio = that.authService.getIdEspacio();
			const idAla =  that.nodoSeleccionado.ENTIDAD.SECCION.ALA.Id;

			return that.sws.wsObtenerLLFromXY(token, that.nodoSeleccionado.X, that.nodoSeleccionado.Y, idEspacio, idAla).toPromise();

		})
		.then(function (ll) {
			that.nodoSeleccionado.ENTIDAD.Latitud = ll.Latitud;
			that.nodoSeleccionado.ENTIDAD.Longitud = ll.Longitud;

			const borrar = []; // baliza_has_nodo
			const crear: BalizaFormulario[] = []; // BALIZA
			that.nodoSeleccionado.balizas.forEach(baliza => {

				const encontrado = that.nodoSeleccionado.ENTIDAD.BALIZAS.find( b => b.IdBaliza === baliza.Id);
				if (!encontrado) {
					crear.push(baliza.ENTIDAD);
				}

			});

			that.nodoSeleccionado.ENTIDAD.BALIZAS.forEach(baliza_has_nodo => {

				const encontrado = that.nodoSeleccionado.balizas.find( b => b.Id === baliza_has_nodo.IdBaliza);
				if (!encontrado) {
					borrar.push(baliza_has_nodo);
				}

			});


			return that.guardarRelacionBalizas(borrar, crear);
		})
		.then(function(msg) {

			return that.entityManagerProvider.saveChanges();
		})
		.then(function(msg) {
			that.onElementoGuardado.emit({ result: true, element: that.nodoSeleccionado });
			that.spinner.style.display = 'none';
			return msg;
		})
		.then(function(data: any) {
			console.log(data)
			// Renovamos el Token
			if(data.httpResponse.status === 200){
				that.authService.relogin();
			}
		})
		.catch(function(err) {
			that.onElementoGuardado.emit({ result: false, element: that.nodoSeleccionado });
			that.spinner.style.display = 'none';
			return err;
		});
	}

	guardarRelacionBalizas(borrar, crear: BalizaFormulario[]){
		const that = this;
		const promises = [];
		this.entityManagerProvider.deleteEntityArray(borrar);

		crear.forEach(baliza => {
			promises.push(that.entityManagerProvider.newNODO_has_BALIZA());
		});
		return allSettled(promises)
		.then(function(oNodo_haz_balizaS){

			for (let index = 0; index < oNodo_haz_balizaS.length; index++) {
				const n_b = oNodo_haz_balizaS[index].result;
				const b = crear[index];
				const n =  that.nodoSeleccionado;

				n_b.NODO_Id = n.Id;
				n_b.BALIZA_Id = b.Id;
			}

			return true;
		});
	}

	guardarMultiIdioma(){
		const that = this;
		this.entityManagerProvider.deleteEntityArray(this.nodoSeleccionado.ENTIDAD.IDIOMAS);

		return this.entityManagerProvider.newNodo_IDIOMA(this.nodoSeleccionado.ENTIDAD)
		.then(function(NODO_IDIOMAs){

			NODO_IDIOMAs.forEach(NODO_IDIOMA => {
				const aux = that.nodoSeleccionado.Idiomas.get(NODO_IDIOMA.IDIOMA.Codigo);
				if (aux) {
					NODO_IDIOMA.Nombre = aux.Nombre;
					NODO_IDIOMA.Descripcion = aux.Descripcion;
				}

			});
		});
	}

	public eliminar() {
		this.spinner.style.display = 'inherit';
		const that = this;
		this.eliminarSeleccionado()
		.then(function () {
			that.spinner.style.display = 'none';
			that.onElementoEliminado.emit({ result: true, element: that.nodoSeleccionado });
			that.authService.relogin();

		})
		.catch(function () {
			that.spinner.style.display = 'none';
			that.onElementoEliminado.emit({ result: false, element: that.nodoSeleccionado });
		});
	}

	public eliminarSeleccionado () {
		const that = this;
		if (this.nodoSeleccionado !== undefined) {
			return this.entityManagerProvider.deleteNODO(this.nodoSeleccionado.ENTIDAD);
			// this.entityManagerProvider.deleteCascadaNODOS(this.nodoSeleccionado.ENTIDAD);
			// return this.entityManagerProvider.saveChanges();
		}
	}


	/* Confirmacion */
	mostrarConfirmacion(operacion){
		this.appComponent.showWarn(operacion);
		this.operacion = operacion;
		this.confirmacionVisible = true;
	}

	confirmar(){
		this.msgs = [];
		if (this.operacion === 'guardar') {
			this.guardar();
		}
		else if (this.operacion === 'eliminar'){
			this.eliminar();
		}
	}

	cancelar(){
		this.msgs = [];
		this.operacion = '';
		this.confirmacionVisible = false;
	}

	/* App-Selector_Idioma */
	onIdiomaChange($event) {
		const idioma = $event.value;
		if (!idioma) {
			return;
		}
		this.idiomaSeleccionado = idioma;

		// Cojemos la traduccion del nodo al idioma seleccionado
		let nodoIdioma = this.nodoSeleccionado.Idiomas.get(idioma.value);

		// Si no existe la creamos
		if (!nodoIdioma) {

			nodoIdioma = new NodoIdiomaFormulario();

			this.nodoSeleccionado.Idiomas.set(idioma.value, nodoIdioma);

		}

		// Seteamos los valores de nodoFormulario con los valores del idioma seleccionado
		this.nodoSeleccionado.Nombre = nodoIdioma.Nombre;
		this.nodoSeleccionado.Descripcion = nodoIdioma.Descripcion;

		console.log('Cambiar Titulo y descripcion a la del idioma: ' + idioma.value + '(' + idioma.title + ')');
	}


	onPortalChange($event){
		this.onNodoPortalChange.emit({ result: true, element: {$event, nodo: this.nodoSeleccionado} });
	}

	alaPortalChange(alaPortal){
		this.alaDestinoPortal = alaPortal.value;
		this.onAlaPortalChange.emit(this.alaDestinoPortal);
	}

	/* TAB_MENU */
	tabNodoSeleccionada(event){
		this.activeNODOMenuItem = this.tabNODEMenuItems[0];
		this.tabPortalNodo = false;
		this.tabBalizaNodo = false;
		this.tabEditarNodo = true;
		this.seleccionandoNodoDestino = false;
		this.onNodoPortalCancelPressed.emit();
		if (!this.visibleCrearPortal) {
			this.onAlaPortalChange.emit(this.alaOrigenPortal);
		}

		this.blockUI.style.display = 'none';
	}

	tabPortalesSeleccionada(event){
		this.activeNODOMenuItem = this.tabNODEMenuItems[1];
		this.tabPortalNodo = true;
		this.tabBalizaNodo = false;
		this.tabEditarNodo = false;
		this.seleccionandoNodoDestino = false;
		this.onNodoPortalCancelPressed.emit();
		this.blockUI.style.display = 'inherit';

		this.msgsPortal = [];
		if (!this.nodoSeleccionado.EsPortal) {
			this.msgsPortal.push({severity: 'warn', detail: this.translate.instant('Mapas.avisoportales')});
		}
	}

	tabBalizasSeleccionada(event){
		this.activeNODOMenuItem = this.tabNODEMenuItems[2];
		this.seleccionandoNodoDestino = false;
		this.onNodoPortalCancelPressed.emit();
		this.tabPortalNodo = false;
		this.tabBalizaNodo = true;
		this.tabEditarNodo = false;
		this.blockUI.style.display = 'none';
		const that = this;
		that.nodoSeleccionado.balizas.forEach(baliza => {
			if(baliza.ENTIDAD){
				if(baliza.ENTIDAD.TIPOLOGIA_BALIZA){
					if(baliza.ENTIDAD.TIPOLOGIA_BALIZA.esBeacon === true || baliza.ENTIDAD.TIPOLOGIA_BALIZA.esSniffer === true){
						that.balizasMostrar.push(baliza);
					}
				}
			}
		});
		console.log(that.balizasMostrar)
		return this.entityManagerProvider.getBALIZA()
		.then(function(balizas){
			that.balizas = balizas;
		});
	}


	// PORTAL
	mostrarCrearPortal(mostrar){

		if (mostrar) {
			this.seleccionandoNodoDestino = true;
			this.onNodoPortalCrearPressed.emit();
			this.blockUI.style.display = 'none';

			this.appComponent.showInfo(this.translate.instant('Mapas.seleccionenododestino'));
		}
		else{
			this.seleccionandoNodoDestino = false;
			this.blockUI.style.display = 'inherit';
			this.appComponent.hideAlert();
		}

	}

	verConexion(item){
		console.log(item);
	}

	obtenerPERFIL_MOVILIDAD_CIUDADANO(){
		const that = this;
		const entityManager = that.entityManagerProvider;
		const includes = '';

		that.perfilesMovilidad = [];
		that.perfilesMovilidadDefecto = null;
		const idEspacio = that.authService.getIdEspacio();
		const predicado = new Predicate('IdEspacio', '==', idEspacio);
		return entityManager.getPERFIL_MOVILIDAD_CIUDADANO(predicado, undefined)
		.then(function (entidades) {
			if (entidades == null || entidades.length < 1) {
				console.log('NO HAY PERFILES');
			}
			else {
				console.log('PERFILES CARGADOS CORRECTAMENTE = ' + entidades.length);

				that.perfilesMovilidad = entidades;
				if (that.perfilesMovilidad && that.perfilesMovilidad.length > 0) {
					that.perfilesMovilidadDefecto = that.perfilesMovilidad[0];
				}

				return that.perfilesMovilidad;
			}
		});
	}

	onConexionNodoSeleccionada(item: any){
		this.visibleCrearPortal = !this.visibleCrearPortal;

		this.onConexionPortalSeleccionada.emit(item);

		this.seleccionandoNodoDestino = false;
		this.onNodoPortalCancelPressed.emit();

		this.blockUI.style.display = 'inherit';
	}

	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm){
			that.permisos = perm;
		});
	}

	// BALIZAS
	asignarBalizaPressed(event){
		console.log('asignarBalizaPressed');
		console.log(event);
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioNodo.component.ts